import * as React from 'react';
import { Link } from "react-router-dom";

import { connect, Dispatch } from "react-redux";
import {
    IApplicationState, AppActionCreators,
    IEmailFamilyState, EmailFamilyActionCreators,
    IEmailModelState, EmailModelActionCreators,
    IEmailTemplateState, EmailTemplateActionCreators
} from "@nkr/store/index";
import { IEmailType, IEmailExcelId, IEmailTemplate, IEmailFamilyListResponse, IBaseResponse, IEmailModelListResponse, IEmailTemplateListResponse } from '@nkr/models/index';
import { TableRowWrapper } from './styles';
import { Modal, Alert } from 'react-bootstrap';

interface IEmailEngineOwnProps {
    emailFamilyId: number;
}

interface IEmailEngineStateProps {
    emailFamilies: IEmailFamilyState;
    emailModels: IEmailModelState;
    emailTemplates: IEmailTemplateState;
}

interface IEmailEngineDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getEmailFamilies: () => Promise<IEmailFamilyListResponse>,
    getEmailModels: () => Promise<IEmailModelListResponse>,
    getEmailTemplates: (emailFamilyId: number, emailTypeId: number, emailExcelId: number, emailModelId: number) => Promise<IEmailTemplateListResponse>,
    deleteEmailTemplate: (id: number) => Promise<IBaseResponse>
}

type TEmailEngineProps = IEmailEngineStateProps & IEmailEngineDispatchProps & IEmailEngineOwnProps;

interface IState {
    selectedEmailFamilyId: number,
    selectedEmailTypeId: number,
    selectedEmailExcelId: number,
    selectedEmailModelId: number,
    emailTypes: Array<IEmailType>,
    emailExcelIds: Array<IEmailExcelId>,
    emailTemplates: Array<IEmailTemplate>,
    delete: {
        show: boolean,
        firstDelete: boolean,
        id: number
    },
    message: {
        show: boolean,
        success: boolean,
        text: string
    }
}

class EmailEngine extends React.Component<TEmailEngineProps, IState>{
    readonly state: IState = {
        selectedEmailFamilyId: -1,
        selectedEmailTypeId: -1,
        selectedEmailExcelId: -1,
        selectedEmailModelId: -1,
        emailTypes: [],
        emailExcelIds: [],
        emailTemplates: [],
        delete: {
            show: false,
            firstDelete: true,
            id: 0
        },
        message: {
            show: false,
            success: true,
            text: ""
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.props.showLoading("Getting email templates...").then(() => {
            Promise.all([
                this.props.getEmailFamilies(),
                this.props.getEmailModels(),
                this.props.getEmailTemplates(this.state.selectedEmailFamilyId, this.state.selectedEmailTypeId, this.state.selectedEmailExcelId, this.state.selectedEmailModelId)
            ]).then((response: any) => {
                this.props.hideLoading();
            });
        });
    }

    getTemplates = () => {
        this.props.showLoading("Getting email templates...").then(() => {
            this.props.getEmailTemplates(this.state.selectedEmailFamilyId, this.state.selectedEmailTypeId, this.state.selectedEmailExcelId, this.state.selectedEmailModelId).then(() => {
                this.props.hideLoading();
            });
        });
    }

    public emailFamilyChange = (e: React.FormEvent<HTMLSelectElement>) => {
        var selectedEmailFamily;
        var selectedEmailFamilyId = parseInt(e.currentTarget.value);
        var emailTypes = [];

        selectedEmailFamily = this.props.emailFamilies.list.filter(family => family.id == selectedEmailFamilyId)[0];

        if (selectedEmailFamily != null) {
            emailTypes = selectedEmailFamily.emailTypes;
        }

        this.setState({
            selectedEmailFamilyId: selectedEmailFamilyId,
            selectedEmailTypeId: -1,
            emailTypes: emailTypes,
            emailExcelIds: []
        });
    }

    public emailTypeChange = (e: React.FormEvent<HTMLSelectElement>) => {
        var selectedEmailTypeId = parseInt(e.currentTarget.value);
        var selectedEmailType;
        var emailExcelIds = [];

        if (this.state.emailTypes.length > 0) {
            selectedEmailType = this.state.emailTypes.filter(emailType => emailType.id == selectedEmailTypeId)[0];
            emailExcelIds = selectedEmailType.emailExcelIds;
        }

        this.setState({
            selectedEmailTypeId: selectedEmailTypeId,
            emailExcelIds: emailExcelIds
        });
    }

    public emailExcelIdChange = (e: React.FormEvent<HTMLSelectElement>) => {
        var selectedEmailExelId = parseInt(e.currentTarget.value);

        this.setState({
            selectedEmailExcelId: selectedEmailExelId
        });
    }

    public emailModelChange = (e: React.FormEvent<HTMLSelectElement>) => {
        var selectedEmailModelId = parseInt(e.currentTarget.value);

        this.setState({
            selectedEmailModelId: selectedEmailModelId
        });
    }

    public filterOnClick = () => {
        this.getTemplates();
    }

    public removeFilters = () => {
        this.setState({
            selectedEmailFamilyId: -1,
            selectedEmailTypeId: -1,
            selectedEmailExcelId: -1,
            selectedEmailModelId: -1
        }, () => {
            this.getTemplates()
        });
    }

    public confirmDelete = (id: number) => {
        this.setState({
            delete: {
                show: true,
                firstDelete: true,
                id
            }
        });
    }

    public cancelDelete = () => {
        this.setState({
            delete: {
                show: false,
                firstDelete: true,
                id: 0
            }
        });
    }

    public deleteTemplateFirst = () => {
        this.setState({
            delete: { ...this.state.delete, firstDelete: false }
        });
    }

    public deleteTemplateFinal = () => {
        this.props.showLoading("Delete email template, one moment please...").then(() => {
            this.props.deleteEmailTemplate(this.state.delete.id).then((response) => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        delete: { ...this.state.delete, show: false },
                        message: {
                            show: true,
                            success: true,
                            text: "Template deleted successfully"
                        }
                    }, () => {
                        this.props.getEmailTemplates(this.state.selectedEmailFamilyId, this.state.selectedEmailTypeId, this.state.selectedEmailExcelId, this.state.selectedEmailModelId);
                    });
                } else {
                    this.setState({
                        delete: { ...this.state.delete, show: false },
                        message: {
                            show: true,
                            success: false,
                            text: "Unable to delete template: " + response.data.message
                        }
                    });
                }

                window.scrollTo(0, 0);
            });
        });
    }

    closeAlert = () => {
        this.setState({
            message: { ...this.state.message, show: false }
        });
    }

    public render() {
        const templateToDelete = this.props.emailTemplates.list.find(t => t.id == this.state.delete.id);
        const templateName = templateToDelete != null ? templateToDelete.subject : "";

        return (
            <>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <h2 style={{ marginTop: 0, marginBottom: 20 }}>Email Templates</h2>
                        </div>
                    </div>

                    {this.state.message.show ?
                        <div className="row">
                            <div className="col-xs-12">
                                <Alert bsStyle={this.state.message.success ? "success" : "danger"} onDismiss={this.closeAlert}>
                                    {this.state.message.text}
                                </Alert>
                            </div>
                        </div>
                        : null}

                    <div className="row">
                        <div className="form-group col-xs-12 col-sm-3">
                            <label className="control-label" htmlFor="emailFamilySelector">
                                Email Family
                            </label>
                            <div style={{ marginLeft: 5 }}>
                                <select value={this.state.selectedEmailFamilyId} className="form-control input-medium" onChange={this.emailFamilyChange}>
                                    <option value="-1">- select -</option>
                                    {this.props.emailFamilies.list.map((family, index) =>
                                        <option key={index} value={family.id}>{family.name}</option>
                                    )};
                            </select>
                            </div>
                        </div>
                        <div className="form-group col-xs-12 col-sm-3">
                            <label className="control-label" htmlFor="emailTypeSelector">
                                Email Type
                            </label>
                            <div style={{ marginLeft: 5 }}>
                                <select value={this.state.selectedEmailTypeId} className="form-control input-medium" onChange={this.emailTypeChange}>
                                    <option value="0">- select -</option>
                                    {this.state.emailTypes.map((type, index) =>
                                        <option key={index} value={type.id}>{type.name}</option>
                                    )};
                            </select>
                            </div>
                        </div>

                        <div className="form-group col-xs-12 col-sm-4">
                            <label className="control-label" htmlFor="excelIdSelector">
                                Excel ID
                            </label>
                            <div style={{ marginLeft: 5 }}>
                                <select value={this.state.selectedEmailExcelId} className="form-control input-medium" onChange={this.emailExcelIdChange}>
                                    <option value="0">- select -</option>
                                    {this.state.emailExcelIds.map((excelIds, index) =>
                                        <option key={index} value={excelIds.id}>{excelIds.name}</option>
                                    )};
                            </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-xs-12">
                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <div style={{ marginRight: 10 }}>
                                    <label className="control-label" htmlFor="emailModelSelector">
                                        Email Model
                                    </label>
                                    <div style={{ marginLeft: 5 }}>
                                        <select value={this.state.selectedEmailModelId} className="form-control" onChange={this.emailModelChange}>
                                            <option value="0">- select -</option>
                                            {this.props.emailModels.list.map((model, index) =>
                                                <option key={index} value={model.id}>{model.description}</option>
                                            )};
                                    </select>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: 5 }}>
                                        <button className="btn btn-primary" onClick={this.filterOnClick}>
                                            Filter
                                    </button>
                                    </div>

                                    <div>
                                        <button className="btn btn-link" onClick={this.removeFilters}>
                                            Remove Filters
                                    </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <table className="table table-striped table-hover table-condensed">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Subject</th>
                                    <th>Options</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.emailTemplates.list.map((template, i) =>
                                    <TableRowWrapper key={i}>
                                        <td>{template.id}</td>
                                        <td>{template.subject}</td>
                                        <td>
                                            <Link to={"/email-template/" + template.id} className="btn btn-primary" style={{ paddingTop: 5, paddingRight: 10, paddingBottom: 5, paddingLeft: 10, marginRight: 5 }}>
                                                Edit
                                        </Link>
                                            <Link to={"/email-template-preview/" + template.id} className="btn btn-primary" style={{ paddingTop: 5, paddingRight: 10, paddingBottom: 5, paddingLeft: 10, marginRight: 5 }}>
                                                Preview
                                        </Link>
                                            <button type="button" className="btn btn-danger" style={{ paddingTop: 5, paddingRight: 10, paddingBottom: 5, paddingLeft: 10, marginRight: 5 }} onClick={() => this.confirmDelete(template.id)}>
                                                Delete
                                        </button>
                                        </td>
                                    </TableRowWrapper>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <Modal show={this.state.delete.show} onHide={() => null}>
                    <Modal.Header>
                        <h4>Delete Template?</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ marginBottom: 20 }}>Please confirm that you want to delete the following email template:</div>
                        <div style={{ textAlign: "center", fontWeight: 500, paddingLeft: "5%", paddingRight: "5%" }}>{templateName}</div>

                        {!this.state.delete.firstDelete ?
                            <div style={{ marginTop: 30, textAlign: "center", color: "red", fontWeight: 500, fontSize: 16 }}>
                                <div>WARNING! Deletion is permanent and can't be undone!</div>
                                <div style={{ marginTop: 20 }}>Are you sure you want to delete this template??</div>
                            </div>
                            : null}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.state.delete.firstDelete ?
                            <>
                                <button className="btn btn-primary" onClick={this.cancelDelete}>Cancel</button>
                                <button className="btn btn-default" onClick={this.deleteTemplateFirst}>Delete</button>
                            </>
                            :
                            <>
                                <button className="btn btn-primary" onClick={this.cancelDelete}>No, Cancel</button>
                                <button className="btn btn-danger" onClick={this.deleteTemplateFinal}>Yes, Delete</button>
                            </>
                        }
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IEmailEngineOwnProps): IEmailEngineStateProps => {
    return {
        emailFamilies: appState.emailFamilies,
        emailModels: appState.emailModels,
        emailTemplates: appState.emailTemplates
    }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IEmailEngineDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getEmailFamilies: () => { return dispatch(EmailFamilyActionCreators.getEmailFamily()); },
        getEmailModels: () => { return dispatch(EmailModelActionCreators.getEmailModel()) },
        getEmailTemplates: (emailFamilyId, emailTypeId, emailExcelId, emailModelId) => { return dispatch(EmailTemplateActionCreators.getEmailTemplates(emailFamilyId, emailTypeId, emailExcelId, emailModelId)) },
        deleteEmailTemplate: (id) => { return dispatch(EmailTemplateActionCreators.deleteEmailTemplate(id)); }
    };
}

export default connect<IEmailEngineStateProps, IEmailEngineDispatchProps, IEmailEngineOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(EmailEngine);
